import {ClickableSectionList} from './clickable-section-list/clickableSectionList';
import {useSelectedDocContext} from '../../../search-hooks';
import {TocRenderer} from './clickable-section-list/tocRenderer';
import {DocumentSectionsRenderer} from './clickable-section-list/documentSectionsRenderer';

export const ContentSection = () => {
    const selectedDoc = useSelectedDocContext();
    if (selectedDoc === undefined) {
        return (<></>);
    }

    return (
        <>
            {selectedDoc?.hibuTags['sectionType'] &&
                <ClickableSectionList hibuSpans={selectedDoc.hibuTags['sectionType']}
                                      renderingFunction={DocumentSectionsRenderer}/>}
            {selectedDoc?.hibuTags['heading'] &&
                <ClickableSectionList hibuSpans={selectedDoc.hibuTags['heading']} renderingFunction={TocRenderer} />}
        </>
    );
};
